/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js/dist/zone';  // ✅ Required

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Amplify polyfill (needed for AWS Amplify compatibility)
 */
(window as any).global = window;
(window as any).process = { env: { DEBUG: undefined } };
